(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moonnatur-spaces"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('moonnatur-spaces')) {
    customElements.define('moonnatur-spaces', class extends HTMLElement {
      connectedCallback() {
        this._frame = requestAnimationFrame(() => this.init());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this._frame);
        this._events?.abort();
        this._media?.removeEventListener('change', this._orientation);
      }

      init() {
        this._events?.abort();
        this._media?.removeEventListener('change', this._orientation);
        this._buttons = Array.from(this.querySelectorAll('[data-space-tab]'));
        this._panels = Array.from(this.querySelectorAll('[data-space-panel]'));
        this._tabs = this.querySelector('[role="tablist"]');
        if (!this._buttons.length || !this._tabs) return;

        this._events = new AbortController();
        const options = { signal: this._events.signal };
        this._media = window.matchMedia('(max-width: 749px)');
        this._orientation = () => this._tabs.setAttribute('aria-orientation', this._media.matches ? 'horizontal' : 'vertical');
        this._orientation();
        this._media.addEventListener('change', this._orientation);

        this._tabs.addEventListener('click', event => {
          const button = event.target.closest('[data-space-tab]');
          const index = this._buttons.indexOf(button);
          if (index >= 0) this.activate(index);
        }, options);

        this._tabs.addEventListener('keydown', event => {
          const index = this._buttons.indexOf(event.target.closest('[data-space-tab]'));
          if (index < 0) return;
          let next;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this._buttons.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + this._buttons.length) % this._buttons.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this._buttons.length - 1;
          else return;
          event.preventDefault();
          this.activate(next, true);
        }, options);

        this.addEventListener('shopify:block:select', event => {
          const index = this._buttons.findIndex(button => button.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.activate(index);
        }, options);

        this.classList.add('is-ready');
        this.activate(0, false, false);
      }

      activate(index, focus = false, promoteImage = true) {
        const selected = this._buttons[index];
        if (!selected) return;
        this._buttons.forEach(button => {
          const active = button === selected;
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
        });
        this._panels.forEach(panel => {
          const active = panel.dataset.blockId === selected.dataset.blockId;
          panel.hidden = !active;
          if (active && promoteImage) panel.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
        });
        if (focus) selected.focus({ preventScroll: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
